import React from "react";
import ActivityAction from "../ActivityAction/ActivityAction";

const extractEmails = (comment) => {
  return comment.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
};

const getParsedComment = ({ mentionedList, note }, currentUserInfo) => {
  let emailList = extractEmails(note) || [];
  let usersList = JSON.parse(mentionedList) || [];
  let usersEmail = [];
  let myRegExp;

  for (let index = 0; index < emailList.length; index++) {
    const email = emailList[index];
    myRegExp = new RegExp(email, "i");
    note = note.replace(myRegExp, "");
  }

  for (let index = 0; index < usersList.length; index++) {
    const userName = currentUserInfo.firstName + " " + currentUserInfo.lastName;

    myRegExp = new RegExp("@" + userName, "i");

    let olderText = note;
    note = note.replace(myRegExp, `<span class='user-name'>${userName}</span>`);

    if (note !== olderText) {
      usersEmail.push(usersList[index].email);
    }
  }
  return note;
};

const CommentActivityItem = ({
  openDocument,
  document,
  comment,
  isComment,
  isMention,
  isReply,
  currentUserInfo,
  isDocument = true,
}) => {
  const { title, inTrash, id } = document;
  const onClick = () => openDocument(id, true);
  return (
    <>
      {isReply ? (
        <>
          <ActivityAction
            {...{
              onClick,
              title: "replied",
              inTrash,
              isDocument,
            }}
          />
          to the comment below
        </>
      ) : isMention ? (
        <>
          has
          <ActivityAction
            {...{
              onClick,
              title: "mentioned you",
              inTrash,
              isDocument,
            }}
          />
          in a comment on {title}
        </>
      ) : (
        <>
          has left a
          <ActivityAction
            {...{
              onClick,
              title: "comment",
              inTrash,
              isDocument,
            }}
          />
          on {title}
        </>
      )}
      <div>
        <p
          className="comment-text"
          dangerouslySetInnerHTML={{
            __html: getParsedComment(isReply ? comment.parentComment : comment, currentUserInfo),
          }}
        ></p>
      </div>
    </>
  );
};

export default CommentActivityItem;
